// ---  external
import { cva } from "class-variance-authority";
import { ringClasses, invalidRingClasses } from "../../assets/styles";
// -----------------------------------------------------------------------------

export const containerVariants = cva(
  `bg-control-surface shadow-control-default hover:shadow-control-hover text-md autofill control-radius flex items-center gap-3 px-4 py-2 transition-[border-color,opacity,box-shadow] duration-200`,
  {
    variants: {
      width: {
        auto: "w-auto min-w-15",
        full: "w-full"
      },
      hasRing: {
        true: `${ringClasses} ${invalidRingClasses}`,
        false: ""
      }
    },
    defaultVariants: {
      width: "full"
    }
  }
);

export const inputFieldVariants = cva(
  "placeholder:text-faint w-full bg-transparent text-base focus:ring-0 focus:outline-none"
);

// -----------------------------------------------------------------------------
export default {
  input: {
    container: containerVariants,
    field: inputFieldVariants,
    items: cva("flex h-lh items-center justify-center")
  }
};
